import React, { useState } from "react";
import { IGlobalAlert } from "../../interfaces/global-alerts/IGlobalAlert";
import { Paper, Table, TableHead, TableRow, TableCell, TableBody, Tooltip, IconButton, DialogContentText, Fab } from "@material-ui/core";
import * as Styles from "./styles/AlertItemStyles";
import DeleteIcon from "@material-ui/icons/Delete";
import { useHistory } from "react-router";
import EditIcon from "@material-ui/icons/Edit";
import { DialogComponent } from "../auction-management/DialogComponent";
import * as GlobalAlertService from "../../services/GlobalAlertService";
import { useSnackbar, OptionsObject } from "notistack";
import moment from "moment";
import { alertTypeDescription } from "../../interfaces/global-alerts/AlertType";

const variantError: OptionsObject = { variant: "error" };
const variantSuccess: OptionsObject = { variant: "success" };

interface AlertListProps {
  results: IGlobalAlert[];
  refresh: (toPost?: undefined) => void;
}


export const AlertList: React.FC<AlertListProps> = ({ results, refresh }) => {
  const classes = Styles.AlertItemStyles();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const [open, setOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const [selectedNotificationId, setSelectedNotificationId] = useState<string>("");

  const handleDeletion = (id) => {
    setOpen(false);
    setLoading(true);
    GlobalAlertService.Delete(id).then(result => {      
      enqueueSnackbar("Successfully Deleted.", variantSuccess);
      refresh();
      setLoading(false);
    }).catch(async response => {
      enqueueSnackbar("Could not delete alert, please try again.", variantError);
    })
  }

  const DeleteDialog = (id) => {
    setSelectedNotificationId(id);
    setOpen(true);
  };

  if (results.length >= 1) {
    return (

      <div>
        <DialogComponent
          open={open}
          onClose={setOpen}
          title="Confirm deletion of alert"
          changeHandler={handleDeletion}
          contentElement={<DialogContentText>Are you sure you want to remove this alert?</DialogContentText>}
          id={selectedNotificationId}
          buttonDisabled={loading}
        />


        <Paper className={classes.root}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableCell}>
                  <h3 className={classes.margin}>Description</h3>
                </TableCell>
                <TableCell className={classes.tableCell}>
                  <h3 className={classes.margin}>Type</h3>
                </TableCell>
                <TableCell className={classes.tableCell}>
                  <h3 className={classes.margin}>Start Date</h3>
                </TableCell>
                <TableCell className={classes.tableCell}>
                  <h3 className={classes.margin}>End Date</h3>
                </TableCell>                
                <TableCell align="left" className={classes.tableCell}>
                  <h3>&nbsp;</h3>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {results.map((item: IGlobalAlert, index: number) => (
                <TableRow
                  hover
                  key={item.id}
                  role="checkbox"
                  className={classes.tableRow}
                >                  
                  <TableCell style={{ maxWidth: "420px",}}className={classes.tableCell} component="th" scope="row">
                    {item.description}
                  </TableCell>
                  <TableCell className={classes.tableCell} component="th" scope="row">
                    {alertTypeDescription(item.alertType)}
                  </TableCell>
                  <TableCell className={classes.tableCell} component="th" scope="row">
                    {moment(item.startDate).format("DD/MM/YYYY HH:mm")}
                  </TableCell>
                  <TableCell className={classes.tableCell} component="th" scope="row">
                  {moment(item.endDate).format("DD/MM/YYYY HH:mm")}
                  </TableCell>
                  <TableCell className={classes.tableCell} component="th" scope="row">

                    <Tooltip title="Edit alert">
                    <Fab
                        color="primary"
                        aria-label="add"
                        size="small"
                        onClick={() => history.push(`/Alerts/Edit/${item.id}`)}
                    >
                      <EditIcon/>
                    </Fab>

                    </Tooltip>

                    <Tooltip title="Delete alert">

                    <Fab
                        color="secondary"
                        aria-label="add"
                        size="small"
                        style={{ marginLeft: "8px", marginTop: "15px", marginBottom: "15px" }}
                        onClick={() => {
                          DeleteDialog(item.id);
                          setOpen(true);
                        }}
                        >
                          <DeleteIcon/>
                        </Fab>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </div>
    );
  } else {
    return <h2>No alerts found</h2>;
  }
};


